import { HelpCircleIcon } from './HelpCircleIcon';

/**
 * author: Google
 * id 49B41103-DD15-4FF4-A18A-44D8586704B6
 * name help-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/help-circle.svg
 * tags
 */
export const QuestionMarkCircleIcon = HelpCircleIcon;
export default QuestionMarkCircleIcon